<template>
  <div>
    <v-snackbar multi-line vertical :timeout="9999999999" :value="true" bottom color="highlight" @input="close">
      {{`${blueprint.lockedByUserName} ${this.$t("blueprintLockedSince")} ${blueprint.lockedTs}`}}
      <v-card-actions>
        <v-spacer></v-spacer>
      
        <v-btn color="white" small class="mr-1" text @click="close">{{$t('close')}}</v-btn>
          <can I="update" a="blueprints">
          <v-btn outlined color="white" @click="takeover">{{$t('takeOver')}}</v-btn>
        </can>
      </v-card-actions>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["blueprint", "showLockedMessage"],
  methods: {
    close() {
      this.$emit("close");
    },
    takeover() {
      this.$http
        .takeOverBlueprintEdit(this.blueprint.id)
        .then(res => {
          this.$router.push({
            name: "EditBlueprintsDetails",
            params: { id: this.blueprint.id }
          });
        })
        .catch(err => {
          this.$noty.info(err);
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pages/Blueprints/IsLocked.vue